export default "__VITE_ASSET__DK4tmd96__"